<template>
  <DrinksPage />
</template>

<script>
import DrinksPage from '@/pages/DrinksPage.vue'

export default {
  name: 'App',
  components: {
    DrinksPage
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #DFF6FF;
  margin-top: 10px;
}
</style>
